import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'config/axios';
import { setuserErrors,setRoles} from '../../../stores/modules/idp/userreducer'
export const fetchRolesService = createAsyncThunk('company/fetchRoles', async ({params}, { dispatch }) => {
  dispatch(setuserErrors([]));
    try {
      let response = await axios.get(`${process.env.REACT_APP_IDP_ROLE_ENDPOINT_URL}/getRolesBycompany`, {
      params: params,
      });
      dispatch(setRoles(response.data));
    } catch (error) {
      dispatch(setuserErrors(error.response));
    }
  });

  export const userActivateService= async({userId}) => {
    try
    { 
      let response = await axios.put(`${process.env.REACT_APP_IDP_USER_ENDPOINT_URL}/user/activate/${userId}`,{});
      if(response?.status===200){
        return response.status;
      }
      else
        return response.status
    }
    catch(error)
    {
      return error;
    }
  }

  export const userDeactivateService= async({userId} ) => {
    try
    { 
      let response = await axios.put(`${process.env.REACT_APP_IDP_USER_ENDPOINT_URL}/user/deactivate/${userId}`,{});
      if(response?.status===200){
        return response.status;
      }
      else
        return response.status
    }
    catch(error)
    {
      return error;
    }
  }
  export const addUserService= async(data) => {
    try
    { 
      let response = await axios.post(`${process.env.REACT_APP_IDP_USER_ENDPOINT_URL}/user`,data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    return response;
    }
    catch(error)
    {
      return error;
    }
  }
  export const getUserService= async(userId) => {
    try
    { 
      let response = await axios.get(`${process.env.REACT_APP_IDP_USER_ENDPOINT_URL}/user/${userId}`,{});
      return response?.data;
    }
    catch(error)
    {
      return error;
    }
  }
  export const updateUserService= async(userId,data) => {
    try
    { 
      let response = await axios.put(`${process.env.REACT_APP_IDP_USER_ENDPOINT_URL}/user/${userId}`,data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    return response;
    }
    catch(error)
    {
      return error;
    }
  }
  export const getAllUsersService= async(params) => {
    try
    { 
      let response = await axios.get(`${process.env.REACT_APP_IDP_USER_ENDPOINT_URL}/users`,{params:params});
    return response?.data;
    }
    catch(error)
    {
      return error;
    }
  }
  export const getAllCAPUsersService= async(params) => {
    try
    { 
      let response = await axios.get(`${process.env.REACT_APP_CAP_ENDPOINT_URL}/standards/getusers`,{params:params});
    return response?.data?.data;
    }
    catch(error)
    {
      return error;
    }
  }
  export const deleteUserService = async(userId) =>{
    try
    { 
      let response = await axios.delete(`${process.env.REACT_APP_IDP_USER_ENDPOINT_URL}/user/${userId}`,{});
      return response?.data;
    }
    catch(error)
    {
      return error;
    }
  }